import { FC } from 'react';

import { Box } from '@mui/material';

import AuditLogsDataGrid from '@/pages/AgencyList/AuditLogsDataGrid';

export const AuditLogsPage: FC = () => {
  return (
    <Box>
      <AuditLogsDataGrid />
    </Box>
  );
};
